var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "ConnectionError",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-connection-error","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M247.3 73.2c-13.8-8-27.9-14.6-42.3-19.8l43.5-43.5c2.1-2.1 2.1-5.6 0-7.8-2.1-2.1-5.6-2.1-7.8 0l-47.4 47.4c-12.9-3.9-26-6.7-39.3-8.3-25.7-3.1-51.9-1.8-77.8 3.9C32 54.8 4.1 73.6 2.9 74.4.4 76.1-.3 79.5 1.5 82c1.1 1.6 2.8 2.4 4.6 2.4 1.1 0 2.2-.3 3.1-1 .2-.1 27.6-18.5 69.8-27.6 24.7-5.4 49.6-6.6 74-3.6 10.6 1.3 21 3.4 31.4 6.2l-39.8 39.8c-21-2.4-39.7-.4-54.3 2.9-31.5 7.1-51.4 20.8-52.2 21.4-2.5 1.7-3.1 5.2-1.3 7.7 1.1 1.5 2.8 2.3 4.5 2.3 1.1 0 2.2-.3 3.2-1 .2-.1 19.3-13.2 48.7-19.7 14-3.1 27.8-4.2 41.4-3.5L1.6 241.1c-2.1 2.1-2.1 5.6 0 7.8 1.1 1.1 2.5 1.6 3.9 1.6s2.8-.5 3.9-1.6l65.5-65.5c.4.1.7.1 1.1.1 1.1 0 2.1-.3 3.1-.9.1-.1 11.3-7.4 28.3-11 22.5-4.8 44-1.2 64 10.7 2.6 1.6 6 .7 7.6-1.9 1.6-2.6.7-6-1.9-7.5-28.2-16.7-54.9-15.7-72.4-11.9-3.6.8-6.9 1.7-10 2.7l54-54c19.8 3 39.1 10.1 57.8 21.3 2.6 1.6 6 .7 7.6-1.9 1.6-2.6.7-6-1.9-7.5-18.8-11.2-37.1-17.8-54.2-21.2L196.3 62c15.4 5.2 30.6 12 45.4 20.7 2.6 1.5 6 .7 7.6-2 1.5-2.6.6-6-2-7.5z"/>
  <ellipse cx="124.2" cy="225" rx="10.1" ry="10"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/connection-error.svg